import { BoundingSphere, Cartesian3, clone, Matrix4 } from "cesium";
import { IInputObjs3DTile } from "../interfaces/sceneManager.interface";
import { SceneManager } from "../services/sceneManager";
import { InputDataPrimitive } from "../services/styleElement";

interface DataView {
    id: string;
    name: string;
    parentID?: string;
    url?: string;
    translateId?: string;
    contentType?: string;
    loadType?: number;
    isShow: boolean;
    fileVersion?: string;
    fileType?: string;
    isFolder?: boolean
    modelMatrix?: any;
    isLoadDefault?: boolean;
    boundingBoxDefault?: {
        min: { x: number, y: number, z: number },
        max: { x: number, y: number, z: number }
    }
}
export class TileModel {
    tileset?: any;
    sceneManager: SceneManager; // Thêm thuộc tính viewer
    id: string;
    name: string;
    parentID?: string;
    url?: string;
    translateId?: string;
    contentType?: string;
    loadType?: number;
    inputObjs?: IInputObjs3DTile = {
        longitude: undefined,
        latitude: undefined,
        height: undefined,
        x: undefined,
        y: undefined,
        z: undefined,
        maximumScreen: 16,
        sizePointCloud: 2
    }
    isFolder?: boolean = false
    fileType?: string
    originalModelMatrix?: Matrix4
    originalCartgraphic?: any
    primitiveName?: string
    isLoadDefault?: boolean
    inputObjectPrimtive: InputDataPrimitive | undefined
    boundingBoxDefault?: {
        min: { x: number | undefined, y: number | undefined, z: number | undefined },
        max: { x: number | undefined, y: number | undefined, z: number | undefined }
    }
    private _isShow: boolean; // Thay đổi thành thuộc tính riêng tư



    constructor(dataView: DataView, scene: SceneManager) {

        this.sceneManager = scene; // Truyền viewer vào constructor
        this.id = dataView.id;
        this.name = dataView.name;
        this.parentID = dataView.parentID;
        this.url = dataView.url;
        this.translateId = dataView.translateId;
        this.contentType = dataView.contentType;
        this.loadType = dataView.loadType;
        this._isShow = dataView.isShow;
        this.isFolder = dataView.isFolder
        this.fileType = dataView.fileType
        this.isLoadDefault = dataView.isLoadDefault
        this.boundingBoxDefault = dataView.boundingBoxDefault
    }
    // Getter cho isShow
    public get isShow(): boolean {
        return this._isShow;
    }

    // Setter cho isShow
    public set isShow(value: boolean) {
        this._isShow = value;
        this.showHide(value)


    }

    async getTileSet(): Promise<void> {
        const maxRetries = 3;
        let attempt = 0;
        while (attempt < maxRetries) {
            try {
                if (this.loadType == 1) {
                    const resultLoadId = await this.sceneManager.load3DTileById(this.translateId!, undefined, this.inputObjs)
                    this.tileset = resultLoadId.tileSet || undefined;
                    this.url = resultLoadId.url || undefined;
                    this.primitiveName = resultLoadId.dataConnect?.data?.folder;
                } else {
                    if (this.url) {
                        this.tileset = await this._tileSetContentType(this.url!, this.contentType!);
                    }
                }

                this.setOriginalModelMatrix();
                // Nếu tileset không hợp lệ (undefined, null, false) thì retry
                // if (this.inputObjs?.z) {
                //     this.setTransformZ(this.inputObjs.z);
                // }
                // if (this.inputObjs?.x && this.inputObjs?.y && this.inputObjs?.height) {
                //     this.setModelMatrix({
                //         longitude: this.inputObjs.longitude,
                //         latitude: this.inputObjs.latitude,
                //         height: this.inputObjs.height
                //     });
                // }
                return; // Thành công, thoát khỏi hàm
            } catch (error) {
                console.log("Retrying TileModel");
                attempt++;
                // await new Promise(res => setTimeout(res, 200)); // Nếu muốn delay
            }
        }
    }

    //#region setOriginalModelMatrix
    setOriginalModelMatrix() {
        if (this.tileset && !this.originalCartgraphic) {
            this.originalModelMatrix = clone(this.tileset.modelMatrix)
            this.originalCartgraphic = this.sceneManager.getCurrentCartographic(this.tileset)
        }
    }

    private _tileSetContentType = async (url: string, contentType: string) => {
        let tile;
        switch (contentType) {
            case '3dtile':
                tile = await this.sceneManager.load3DTileUrl(url, this.inputObjs);

                break;
            case 'kmz':
                tile = await this.sceneManager.loadKmz(url, this.inputObjs);

                break;
            default:
                break
        }
        return tile
    }


    private actionQueue = Promise.resolve();

    async showHide(show: boolean): Promise<void> {
        // Đưa toàn bộ logic vào queue
        this.actionQueue = this.actionQueue.then(async () => {

            if (show) {
                await this.getTileSet();
                if (!this.isFolder) {
                    this.sceneManager.setPositionModel(this.tileset, this.inputObjs);
                }
            } else {
                if (this.tileset) {
                    if (this.contentType == 'kmz') {
                        this.sceneManager.removeKmz(this.tileset)
                    } else {
                        this.tileset.modelMatrix = this.originalModelMatrix;
                        this.sceneManager.removeTileSet(this.tileset);
                    }
                    this.tileset = undefined;
                }
            }

        }).catch(e => console.error("Lỗi showHide queue:", e));

        return this.actionQueue;
    }



    zoomTo(): void {
        if (this.tileset) {
            this.sceneManager.zoomTo(this.tileset); // Sử dụng `this.viewer` thay vì `Folder.viewer`
        }
    }


    // Phương thức đệ quy để duyệt qua tất cả các thư mục con và lấy bounding
    private getBoundingVolumes(children: any): BoundingSphere[] {
        let boundingVolumes: BoundingSphere[] = [];

        // Nếu thư mục này có tileset, lấy bounding volume và thêm vào danh sách
        children.forEach((item: any) => {
            if (item.tileset) {
                if (item.contentType == '3dtile') {
                    const boundingVolume = item.tileset.boundingSphere;
                    if (boundingVolume) {
                        boundingVolumes.push(boundingVolume);
                    }
                } else if (item.contentType == 'kmz') {
                    const boundKmz = this.sceneManager.getBoundingBoxFromKMZ(item.tileset)
                    if (boundKmz) {
                        boundingVolumes.push(boundKmz)
                    }
                }
            }
        })

        return boundingVolumes;
    }

    // Tính toán bounding box chung từ tất cả bounding volumes
    getCombinedBoundingBox = (children: any) => {
        // Khởi tạo điểm min và max ban đầu
        let combinedMin: Cartesian3 = new Cartesian3(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY);
        let combinedMax: Cartesian3 = new Cartesian3(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY);

        // Lấy tất cả các bounding volumes
        const boundingVolumes = this.getBoundingVolumes(children);
        if (boundingVolumes.length == 0) return null
        // Lặp qua tất cả các bounding volumes để tính toán min/max
        boundingVolumes.forEach((boundingVolume) => {
            const center = boundingVolume.center;
            const radius = boundingVolume.radius;

            // Tính toán các điểm cực trị (min, max) cho từng BoundingSphere
            const volumeMin = new Cartesian3(center.x - radius, center.y - radius, center.z - radius);
            const volumeMax = new Cartesian3(center.x + radius, center.y + radius, center.z + radius);

            // Cập nhật điểm min và max chung
            combinedMin = new Cartesian3(
                Math.min(combinedMin.x, volumeMin.x),
                Math.min(combinedMin.y, volumeMin.y),
                Math.min(combinedMin.z, volumeMin.z)
            );

            combinedMax = new Cartesian3(
                Math.max(combinedMax.x, volumeMax.x),
                Math.max(combinedMax.y, volumeMax.y),
                Math.max(combinedMax.z, volumeMax.z)
            );
        });

        return { min: combinedMin, max: combinedMax };
    }

    parentZoomTo(children: any): void {
        if (children.length == 0) return
        // Tính toán bounding box chung
        const boundingBox = this.getCombinedBoundingBox(children);
        if (!boundingBox) return;
        const { min, max } = boundingBox;

        // Tạo BoundingSphere từ min và max
        const center = new Cartesian3(
            (min.x + max.x) / 2,
            (min.y + max.y) / 2,
            (min.z + max.z) / 2
        );

        const radius = Cartesian3.distance(min, max) / 2;



        const combinedBoundingSphere = new BoundingSphere(center, radius);
        // Zoom vào phạm vi bounding sphere chung
        this.sceneManager.cameraFlyToBouding(combinedBoundingSphere);
    }



    async setModelMatrix(position: {
        longitude: number | undefined,
        latitude: number | undefined,
        height: number | undefined,
    }) {
        this.inputObjs = {
            x: undefined,
            y: undefined,
            z: undefined,
            longitude: position.longitude === 0 ? undefined : position.longitude,
            latitude: position.latitude === 0 ? undefined : position.latitude,
            height: position.height === 0 ? undefined : position.height,
        }
        if (this.tileset && this._isShow) {
            if (this.contentType === '3dtile') {
                if (position.longitude === 0 && position.latitude === 0 && position.height === 0) {
                    this.tileset.modelMatrix = this.originalModelMatrix

                } else {

                    this.sceneManager.setModelMatrix(this.tileset, position.longitude, position.latitude, position.height, this.originalCartgraphic)
                }
            } else if (this.contentType === 'kmz') {
                this.sceneManager.removeKmz(this.tileset);

                // Reset lại từ đầu tileset
                this.tileset = await this.sceneManager.loadKmz(this.url!, this.inputObjs);
            }
        }

    }
    //#region setTransformZ
    async setTransformZ(z: number) {
        // console.log("this.tileset", this.tileset)
        this.inputObjs = {
            longitude: undefined,
            latitude: undefined,
            height: undefined,
            z: z === 0 ? undefined : z,

        }

        if (this.tileset && this._isShow) {
            if (z !== 0 && z !== undefined && this.contentType === '3dtile') {
                this.sceneManager.transformZ(this.tileset, z, this.originalCartgraphic);
            }
            else if (this.contentType === 'kmz') {
                // PHẢI await remove trước
                this.sceneManager.removeKmz(this.tileset);

                // Chỉ load sau khi remove thành công
                this.tileset = await this.sceneManager.loadKmz(this.url!, this.inputObjs);

            }

            else {
                this.tileset.modelMatrix = this.originalModelMatrix

            }
        }
    }


    //#region setMaximumScreenSpaceError
    setMaximumScreenSpaceError(maximumScreenSpaceError: number) {
        this.inputObjs!.maximumScreen = maximumScreenSpaceError
        if (this.tileset && this._isShow && this.contentType === '3dtile') {
            this.tileset.maximumScreenSpaceError = maximumScreenSpaceError;

        }
    }

    setMaximumAttenuation(maximumAttenuation: number) {
        this.inputObjs!.sizePointCloud = maximumAttenuation
        if (this.tileset && this._isShow && this.contentType === '3dtile') {
            const pcs = this.tileset.pointCloudShading;
            if (pcs) {
                pcs.maximumAttenuation = maximumAttenuation;
                // pcs.geometricErrorScale = Math.max(0.3, 1.0 / (pcs.maximumAttenuation / 3));

            }
        }
    }

}